import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {ToastController} from '@ionic/angular';
import {Observable} from 'rxjs';

import { Network } from '@capacitor/network';
@Injectable({
  providedIn: 'root'
})
export class OfflineGuard implements CanActivate {

  networkHandler;
  status;

  constructor(private router: Router,
              private toast: ToastController) {
    this.networkHandler = Network
      .addListener('networkStatusChange', (status) => {
        console.log('Network status changed', status);
        this.status = status;
      });
  }


  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (!this.status) {
      this.status = await Network.getStatus();
    }
    if (!this.status.connected) {
      this.router.navigate(['no-connection']);
      const toast = await this.toast.create({
        duration: 3000,
        message: 'You are offline'
      });
      await toast.present();
      return Promise.resolve(false);
    }

    return Promise.resolve(true);
  }
}
